import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { forgetPasswordService } from "../../services/forgetpassword.service";
import SwalUI from '../../components/ui/swal-ui/swal-ui';
import validator from 'validator';

import "./forget.scss";
import { appActions } from "../../store/app-slice";

const ForgetPasswordPage = () => {
  const defaultURL = useSelector((state) => state.app.defaultURL)
  const { t } = useTranslation("login");
  const dispatch = useDispatch();
  const [isFetching, setIsFetching] = useState(false);
  const emailRef = useRef()

  const requestChangePassword = () => {
    if(!validator.isEmail(emailRef.current.value.trim())){
      emailRef.current.focus()
      emailRef.current.classList.add('inp-error')
      return false
    } else {
      emailRef.current.classList.remove('inp-error')
    }

    setIsFetching(true)
    dispatch(appActions.isSpawnActive(true))
    const formData = new FormData();
    formData.append('email', emailRef.current.value)
    forgetPasswordService(formData).then(res => {
      emailRef.current.value = "";
      dispatch(appActions.isSpawnActive(false))
      setIsFetching(false)
      SwalUI({status: res.status, description: res.description})
    })
  }
  
  return (
    <form id="forgetpassword-page" className="guest-form">
      <figure className="fig-logo">
        <img
          src="https://berdedd.com/backend/images/Logo-Wynnsoft-Management.png"
          className="logo" />
      </figure>
      <h1 className="login-title">Login To Your Account</h1>
      <p className="login-desc">Welcome Back To Wynnsoft Solution Manager</p>

      <div className="input-group">
        <figure className="login-icon">
          <img src={defaultURL + "images/svg/envelope.svg"} />
        </figure>
        <input type="text" placeholder={t("Email")} ref={emailRef} />
      </div>
   
      <div className="rows">
        <div></div>
        <div className="forget-password"> 
          <Link  className="link" to={defaultURL + "login"}>{t("backToLogin")}</Link>
        </div>
      </div>
      <button type="button" className="btn-signin" onClick={requestChangePassword} disabled={isFetching}>{t("Reset")}</button>
      <div className="register-section">
        <h3 className="register-title">{t("OrSignInWith")}</h3>
        <div className="socials">
          <Link to={defaultURL + "register"}>
            <button type="button" className="btn-register ">{t("NewAccountBtn")}</button>
          </Link> 
        </div>
      </div>
      <div className="powerby"> COPY RIGHT @2022 WYNNSOFT SOLUTION CO,LTD</div>
    </form>
  );
};

export default ForgetPasswordPage;
